export function getColorPickerGridCellStyles(props) {
    var _a;
    var theme = props.theme, circle = props.circle, height = props.height, width = props.width;
    var effects = theme.effects;
    var borderRadiusStyle = { borderRadius: effects.roundedCorner2 };
    if ((height && height > 32 && height <= 64) || (width && width > 32 && width <= 64)) {
        borderRadiusStyle = { borderRadius: effects.roundedCorner4 };
    }
    else if ((height && height > 64) || (width && width > 64)) {
        var largestRadius = (_a = effects.roundedCorner8) !== null && _a !== void 0 ? _a : '8px';
        borderRadiusStyle = {
            borderRadius: largestRadius,
        };
    }
    var styles = {
        colorCell: [!circle && borderRadiusStyle],
        svg: [!circle && borderRadiusStyle],
    };
    return styles;
}
//# sourceMappingURL=ColorPickerGridStyles.styles.js.map